import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import LoadingPlaceholder from './LoadingPlaceholder';
import { CURRENCY, getCurrencySymbol } from '../../../../constants/currency';
import PriceBreakdownRow from './PriceBreakdownRow';

const propTypes = {
  loading: PropTypes.bool,
  pricing: PropTypes.shape({
    total_price: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
    total_shipping_cost: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
    total_tax: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
  }),
  className: PropTypes.string,
};

const PriceBreakdownList = ({ loading, pricing, className }) => {
  const classes = classNames({
    'price-breakdown': true,
    'is-loading': loading,
    [className]: !!className,
  });

  if (loading || !pricing) {
    return <LoadingPlaceholder className={classes} />;
  }

  const total = pricing.total_price.value;
  const tax = pricing.total_tax.value;
  const shipping = pricing.total_shipping_cost.value;
  const subTotal = total - tax - shipping;
  const symbol = getCurrencySymbol(pricing.total_price.currency);

  const rows = [
    {
      label: 'Subtotal',
      value: subTotal,
    },
    {
      label: 'Taxes',
      value: tax,
    },
    {
      label: 'Shipping & handling',
      value: shipping,
    },
    {
      label: 'Total',
      value: total,
    },
  ];

  return (
    <div className={classes}>
      {rows.map(row => (
        <PriceBreakdownRow
          key={row.label}
          label={row.label}
          currencySymbol={symbol}
          value={row.value}
        />
      ))}
    </div>
  );
};

PriceBreakdownList.propTypes = propTypes;

export default PriceBreakdownList;
